export const SNACKBAR_VARIANTS = {
    success: {
        options: {
            position: 'bottom',
            style: {
                backgroundColor: '#021D16',
                color: '#1CF0BE',
                borderRadius: '0.75rem',
                fontWeight: '600',
            },
        },
    },
    error: {
        options: {
            position: 'bottom',
            style: {
                backgroundColor: '#3F0E2B',
                color: '#F5B6E1',
                borderRadius: '0.75rem',
                fontWeight: '600',
            },
        },
    },
    info: {
        options: {
            position: 'bottom',
            style: {
                backgroundColor: '#191C45',
                color: '#B2C2FE',
                borderRadius: '0.75rem',
                fontWeight: '600',
            },
        },
    },
};
